export default __webpack_public_path__ + "static/media/GianinaLovelace.077517aa.png";